import React from 'react';
import PropTypes from 'prop-types';

import LabeledSelectBox from 'components/consumer/LabeledSelectBox';

const addressTypeOptions = [
  {
    label: 'Residential',
    value: '0',
  },
  {
    label: 'Commercial',
    value: '1',
  },
];

const TradeAddressTypeField = ({
  id = 'commercial_address',
  name = 'commercial_address',
  value,
  error,
  isTouched,
  handleBlur,
  setFieldValue,
  setFieldTouched,
  updateShipping,
  isRequired = false,
}) => (
  <LabeledSelectBox
    id={id}
    name={name}
    searchable={false}
    clearable={false}
    options={addressTypeOptions}
    label="Address type"
    onChange={event => {
      setFieldValue(name, event.target.value);
      setFieldTouched(name);

      if (updateShipping) {
        updateShipping({
          commercial_address: event.target.value,
        });
      }
    }}
    onBlur={handleBlur}
    value={value}
    autoComplete="commercial_address"
    data-xc="shipping-commercial_address-field"
    errorMessage={isTouched && error ? error : null}
    required={isRequired ? '' : undefined}
    aria-required={isRequired ? '' : undefined}
  />
);

TradeAddressTypeField.propTypes = {
  error: PropTypes.string,
  handleBlur: PropTypes.func,
  id: PropTypes.string,
  isRequired: PropTypes.bool,
  isTouched: PropTypes.bool,
  name: PropTypes.string,
  setFieldTouched: PropTypes.func,
  setFieldValue: PropTypes.func,
  updateShipping: PropTypes.func,
  value: PropTypes.string,
};

export default TradeAddressTypeField;
